import type { CSSProperties } from 'react';
import { Box, HStack, VStack } from '@cbhq/cds-web/layout';
import { Avatar } from '@cbhq/cds-web/media/Avatar';
import { Text } from '@cbhq/cds-web/typography/Text';
import { defineMessages, useIntl } from '@cbhq/i18n';

const ACTOR_ROW_HEIGHT = 60;

const truncateStyle: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const messages = defineMessages({
  actor: {
    id: 'auditLogActorSection.actor',
    defaultMessage: 'Actor',
    description: 'Section title for audit log actor in detail view',
  },
});

type AuditLogActorSectionProps = {
  name: string;
  email?: string;
  avatarUrl?: string;
};

export function AuditLogActorSection({ name, email, avatarUrl }: AuditLogActorSectionProps) {
  const { formatMessage } = useIntl();

  return (
    <VStack width="100%" gap={0}>
      <Box width="100%" paddingX={3} paddingY={0.5}>
        <Text as="p" font="headline" color="fg">
          {formatMessage(messages.actor)}
        </Text>
      </Box>
      <Box width="100%" paddingX={1.5}>
        <Box width="100%" height={ACTOR_ROW_HEIGHT} justifyContent="center" paddingX={1.5}>
          <HStack alignItems="center" gap={1} width="100%">
            <Avatar
              colorScheme="gray"
              name={name}
              alt={name}
              src={avatarUrl || undefined}
              shape="circle"
            />
            <VStack minWidth={0}>
              <Text as="span" font="headline" color="fg" style={truncateStyle}>
                {name}
              </Text>
              {email ? (
                <Text as="span" font="label2" color="fgMuted" style={truncateStyle}>
                  {email}
                </Text>
              ) : null}
            </VStack>
          </HStack>
        </Box>
      </Box>
    </VStack>
  );
}
